const devDebugEnabled = true;
// Returns if the current context is development and debug is enabled
export const isDev = devDebugEnabled && process.env.NODE_ENV === 'development';